<template>
  <div class="section-label">
    <span class="section-label__text">{{ text }}</span>
    <SvgIcon v-if="required" name="svg/cs_tips.svg" class="section-label__required" />
    <span v-if="tip" class="section-label__tip">{{ tip }}</span>
  </div>
</template>

<script setup lang="ts">
import SvgIcon from '@/components/SvgIcon.vue'

defineProps<{
  /** 标签文案，例如 选择问题分类 */
  text: string
  /** 是否必填，展示红色必填图标 */
  required?: boolean
  /** 右侧补充提示，例如 (内容介于20~200字) */
  tip?: string
}>()
</script>

<style scoped lang="scss">
.section-label {
  display: flex;
  align-items: center;
  gap: 6px;

  &__text {
    font-size: 14px;
    line-height: 22px;
    color: #fff;
  }

  &__required {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }

  &__tip {
    font-size: 12px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.5);
  }
}
</style>
